import module from 'recursoshumanos/module.js'
import template from './template.html'

export class RecursoshumanosComparativasuanominaExportarComponent {
  empresaId
  periodo
  mes
  onClose
  exportando = false
  resultado = null

  constructor (RecursoshumanosComparativasuanominaReporteService) {
    this.RecursoshumanosComparativasuanominaReporteService = RecursoshumanosComparativasuanominaReporteService
  }

  exportar () {
    if (this.exportando) return

    this.exportando = true

    this.RecursoshumanosComparativasuanominaReporteService.get(this.empresaId, this.periodo, this.mes)
      .then(({data}) => (this.resultado = data))
      .finally(() => (this.exportando = false))
  }

  descargar () {
    this.resultado.save()
  }

  cerrar () {
    this.onClose()
  }
}

module.component('recursoshumanosComparativasuanominaExportar', {
  controller: RecursoshumanosComparativasuanominaExportarComponent,
  template,
  bindings: {
    empresaId: '<',
    periodo: '<',
    mes: '<',
    onClose: '&',
  },
})



// WEBPACK FOOTER //
// ./src/recursoshumanos/components/comparativaSuaNomina/exportar/component.js